module.exports = __webpack_public_path__ + "img/bz.9bedf479.png";